import { render, staticRenderFns } from "./StickerPrice.vue?vue&type=template&id=d5152c6e&"
import script from "./StickerPrice.vue?vue&type=script&lang=ts&"
export * from "./StickerPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports